import { render, staticRenderFns } from "./roadbook.vue?vue&type=template&id=bf37dd60&"
import script from "./roadbook.vue?vue&type=script&lang=js&"
export * from "./roadbook.vue?vue&type=script&lang=js&"
import style0 from "./roadbook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports